import { render, staticRenderFns } from "./RegistrarNuevaRemesaDialogComponent.vue?vue&type=template&id=0ef5dc6b"
import script from "./RegistrarNuevaRemesaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarNuevaRemesaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports